// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetMapItemsAsyncRequestModel from '../../model/get-map-items-async-request-model';
import GetMapItemsAsyncRequestDTO from '../dto/get-map-items-async-request-dto';
import dtoSchema from '../schemas/get-map-items-async-request-schema';

export default abstract class GetMapItemsAsyncRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetMapItemsAsyncRequestDTO>) {
    super();
    if (data) {
      this.eventIdentifier = data.eventIdentifier;
      this.categoryId = data.categoryId;
    }
  }
  /**
  * @type {uuid}
  */
  eventIdentifier?: string;
  /**
  */
  categoryId?: number[];

  static toModel(dto: DeepPartial<GetMapItemsAsyncRequestDTO>): GetMapItemsAsyncRequestModel;
  static toModel(dto: DeepPartial<GetMapItemsAsyncRequestDTO> | undefined | null): GetMapItemsAsyncRequestModel | undefined;
  static toModel(dto: DeepPartial<GetMapItemsAsyncRequestDTO> | undefined | null): GetMapItemsAsyncRequestModel | undefined {
    return dto ? new GetMapItemsAsyncRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetMapItemsAsyncRequestModel> | GetMapItemsAsyncRequestModel): GetMapItemsAsyncRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      eventIdentifier: unwrapped.eventIdentifier,
      categoryId: unwrapped.categoryId,
    } as GetMapItemsAsyncRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetMapItemsAsyncRequestModel, can not map to GetMapItemsAsyncRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
